import { jsx as _jsx } from "react/jsx-runtime";
import { Auth0Provider } from '@auth0/auth0-react';
export const Auth0SpaProvider = ({ domain, clientId, redirectUri, audience, children, }) => {
    return (_jsx(Auth0Provider, { domain: domain, clientId: clientId, authorizationParams: { redirect_uri: redirectUri, audience }, children: children }));
};
